module.exports = __webpack_public_path__ + "media/images/icons/twotone/diff-3a950d36568c4be2549e69dbf56172de.svg";